import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonRoundButton } from './RoundButton.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonRoundButton({ prefix }));
}
